import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { t } from "../../lib/i18n";
import { toast } from "sonner";
import AdminBadge from "../../components/AdminBadge";

export default function UsersAdmin() {
  const [users, setUsers] = useState([]);
  const refresh = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { refresh(); }, []);

  const act = async (id, action) => {
    if (action === "ban" && !window.confirm(`${t.ban}?`)) return;
    if (action === "demote" && !window.confirm(`${t.demote}?`)) return;
    try {
      await api.post(`/admin/users/${id}/${action}`);
      const map = { promote: t.promoted, demote: t.demoted, ban: t.bannedToast, unban: t.unbannedToast };
      toast.success(map[action] || t.saved);
      refresh();
    } catch (e) {
      toast.error(e.response?.data?.detail || t.failed);
    }
  };

  return (
    <div className="mt-8">
      <div className="border border-white/10 bg-[#0C0C14]">
        <div className="grid grid-cols-12 px-4 py-3 border-b border-white/10 text-[10px] uppercase tracking-[0.25em] font-bold text-white/40">
          <div className="col-span-3">{t.email}</div>
          <div className="col-span-2">{t.handle}</div>
          <div className="col-span-2">{t.country}</div>
          <div className="col-span-1">Rola</div>
          <div className="col-span-1">{t.banned}</div>
          <div className="col-span-3 text-right">Akcje</div>
        </div>
        {users.map((u) => {
          const isAdmin = u.role === "admin";
          const isBanned = u.banned;
          return (
            <div key={u.id} data-testid={`user-row-${u.id}`} className="grid grid-cols-12 px-4 py-3 border-b last:border-b-0 border-white/5 items-center text-sm">
              <div className="col-span-3 font-mono text-xs truncate flex items-center gap-2">
                {u.email}
                {isAdmin && <AdminBadge />}
              </div>
              <div className="col-span-2 truncate">{u.player?.handle || "—"}</div>
              <div className="col-span-2 font-mono text-xs text-white/50">{u.player?.country || "—"}</div>
              <div className="col-span-1 text-xs uppercase tracking-[0.2em] font-bold text-[#00E5FF]">{u.role}</div>
              <div className="col-span-1">
                {isBanned ? <span className="text-[#FF0055] text-xs">✗</span> : <span className="text-white/30 text-xs">—</span>}
              </div>
              <div className="col-span-3 text-right flex justify-end gap-2 text-[10px] uppercase tracking-[0.2em] font-bold">
                {isAdmin ? (
                  <button onClick={() => act(u.id, "demote")} data-testid={`demote-${u.id}`}
                    className="text-white/70 hover:text-[#FF0055]">{t.demote}</button>
                ) : (
                  <button onClick={() => act(u.id, "promote")} data-testid={`promote-${u.id}`}
                    className="text-white/70 hover:text-[#00E5FF]">{t.promote}</button>
                )}
                {isBanned ? (
                  <button onClick={() => act(u.id, "unban")} data-testid={`unban-${u.id}`}
                    className="text-white/70 hover:text-[#00E5FF]">{t.unban}</button>
                ) : (
                  <button onClick={() => act(u.id, "ban")} data-testid={`ban-${u.id}`}
                    className="text-[#FF0055]">{t.ban}</button>
                )}
              </div>
            </div>
          );
        })}
        {users.length === 0 && (
          <div className="px-4 py-12 text-center text-white/40 font-mono text-sm">{t.none}</div>
        )}
      </div>
    </div>
  );
}
